import { render, staticRenderFns } from "./RiskGradeAssessment.vue?vue&type=template&id=59505502&scoped=true&"
import script from "./RiskGradeAssessment.vue?vue&type=script&lang=js&"
export * from "./RiskGradeAssessment.vue?vue&type=script&lang=js&"
import style0 from "./RiskGradeAssessment.vue?vue&type=style&index=0&id=59505502&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59505502",
  null
  
)

export default component.exports